module.exports = __webpack_public_path__ + "static/media/joystick.1754093d.svg";